import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { BIZ, IMG } from "../lib/content";
import { Reveal } from "./Reveal";

export const CTASection = () => (
  <section data-testid="final-cta" className="relative py-28 lg:py-40 overflow-hidden bg-dst-ink grain">
    <div
      className="absolute inset-0 bg-cover bg-center opacity-25"
      style={{ backgroundImage: `url(${IMG.pitcherSunset})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-dst-ink via-dst-ink/70 to-dst-ink/40" />
    <div className="container-dst relative z-10 text-center">
      <Reveal>
        <span className="eyebrow text-dst-red">Your next level starts here</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-oswald font-700 uppercase leading-[0.9] tracking-tighter text-5xl sm:text-6xl lg:text-8xl">
          Ready To Take Your Game<br />
          <span className="text-dst-red">To The Next Level?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 text-white/70 text-lg max-w-2xl mx-auto">
          Join a group and see what competitive, accountable, elite-level training can do for your athlete — private one-on-one sessions available too.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={BIZ.bookUrl} target="_blank" rel="noreferrer" data-testid="cta-book" className="btn-dst bg-dst-red text-white hover:bg-white hover:text-dst-ink">
            Book Now <ArrowRight size={18} />
          </a>
          <a href={BIZ.phoneHref} data-testid="cta-call" className="btn-dst border border-white/30 text-white hover:bg-white hover:text-dst-ink">
            <Phone size={18} /> Call {BIZ.phone}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
